import { render, staticRenderFns } from "./EventDescription.vue?vue&type=template&id=cc4b4b80&scoped=true"
import script from "./EventDescription.vue?vue&type=script&lang=js"
export * from "./EventDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4b4b80",
  null
  
)

export default component.exports